/**
 * CL-DESIGN-BOARDS-DB-1B — Design Boards permission editor (pure).
 */

import { DESIGN_BOARD_PERMISSION_KEYS } from "./designBoardPermissionKeys";

export const PROJECT_DESIGN_BOARD_PERMISSION_CONTROL_KEYS = Object.freeze([
  DESIGN_BOARD_PERMISSION_KEYS.view,
  DESIGN_BOARD_PERMISSION_KEYS.manage,
  DESIGN_BOARD_PERMISSION_KEYS.contribute,
  DESIGN_BOARD_PERMISSION_KEYS.comment,
]);

export const PROJECT_DESIGN_BOARD_PERMISSION_CONTROL_LABELS = Object.freeze({
  [DESIGN_BOARD_PERMISSION_KEYS.view]: "View design boards (client portal module)",
  [DESIGN_BOARD_PERMISSION_KEYS.manage]: "Manage design boards",
  [DESIGN_BOARD_PERMISSION_KEYS.contribute]: "Contribute design board items",
  [DESIGN_BOARD_PERMISSION_KEYS.comment]: "Comment on design boards",
});

function clonePermissions(permissions = {}) {
  return { ...(permissions || {}) };
}

export function listProjectDesignBoardPermissionControls() {
  return PROJECT_DESIGN_BOARD_PERMISSION_CONTROL_KEYS.map((key) => ({
    key,
    label: PROJECT_DESIGN_BOARD_PERMISSION_CONTROL_LABELS[key],
  }));
}

export function applyDesignBoardPermissionToggle(permissions = {}, key = "", checked = false) {
  const next = clonePermissions(permissions);
  const on = checked === true;
  if (key === DESIGN_BOARD_PERMISSION_KEYS.manage) {
    next[DESIGN_BOARD_PERMISSION_KEYS.manage] = on;
    if (on) next[DESIGN_BOARD_PERMISSION_KEYS.view] = true;
    return next;
  }
  if (key === DESIGN_BOARD_PERMISSION_KEYS.contribute) {
    next[DESIGN_BOARD_PERMISSION_KEYS.contribute] = on;
    if (on) next[DESIGN_BOARD_PERMISSION_KEYS.view] = true;
    return next;
  }
  if (key === DESIGN_BOARD_PERMISSION_KEYS.comment) {
    next[DESIGN_BOARD_PERMISSION_KEYS.comment] = on;
    if (on) next[DESIGN_BOARD_PERMISSION_KEYS.view] = true;
    return next;
  }
  if (key === DESIGN_BOARD_PERMISSION_KEYS.view) {
    next[DESIGN_BOARD_PERMISSION_KEYS.view] = on;
    if (!on) {
      next[DESIGN_BOARD_PERMISSION_KEYS.manage] = false;
      next[DESIGN_BOARD_PERMISSION_KEYS.contribute] = false;
      next[DESIGN_BOARD_PERMISSION_KEYS.comment] = false;
    }
    return next;
  }
  return next;
}

export function isDesignBoardPermissionControlChecked(key = "", permissions = {}) {
  return permissions?.[key] === true;
}

export function shouldShowDesignBoardPermissionsSection() {
  return true;
}

export function applyDeliberateDesignBoardPermissionEdit({ permissions = {}, key = "", checked = false } = {}) {
  return applyDesignBoardPermissionToggle(permissions, key, checked === true);
}

export function normalizeDesignBoardPermissionsForAssignmentSave(
  permissions = {},
  { rawPermissions = null } = {}
) {
  const source = rawPermissions && typeof rawPermissions === "object" ? rawPermissions : permissions;
  const next = clonePermissions(permissions);
  PROJECT_DESIGN_BOARD_PERMISSION_CONTROL_KEYS.forEach((key) => {
    if (typeof source?.[key] === "boolean") {
      next[key] = source[key] === true;
    }
  });
  if (!next[DESIGN_BOARD_PERMISSION_KEYS.view]) {
    next[DESIGN_BOARD_PERMISSION_KEYS.manage] = false;
    next[DESIGN_BOARD_PERMISSION_KEYS.contribute] = false;
    next[DESIGN_BOARD_PERMISSION_KEYS.comment] = false;
    return next;
  }
  if (next[DESIGN_BOARD_PERMISSION_KEYS.manage]) {
    next[DESIGN_BOARD_PERMISSION_KEYS.view] = true;
  }
  if (next[DESIGN_BOARD_PERMISSION_KEYS.contribute]) {
    next[DESIGN_BOARD_PERMISSION_KEYS.view] = true;
  }
  if (next[DESIGN_BOARD_PERMISSION_KEYS.comment]) {
    next[DESIGN_BOARD_PERMISSION_KEYS.view] = true;
  }
  return next;
}
